import React, { useState } from 'react'
import Select from 'react-select'
import { CButton, CCard, CCardBody, CCardFooter, CCardHeader, CCardTitle, CFormLabel, CFormSelect, CModal, CModalBody, CModalFooter, CTooltip, CModalHeader, CModalTitle, CHeader } from '@coreui/react'
import { CircleAlertIcon, Pencil, Trash2, ListOrdered, Info } from 'lucide-react'

const   DisplayQuestion = ({ fetchedQuestions, handleDragStart, handleDragOver, handleDrop, handleDeleteQuestion, handleEditQuestion, setDeleteVisible, setDeleteQuestionIndex }) => {
  const [inputValues, setInputValues] = useState({})
  const [linkedQuestions, setLinkedQuestions] = useState({})

  const handleInputChange = (e, id) => {
    setInputValues((prev) => ({
      ...prev,
      [id]: e.target.value,
    }))
  }

  const handleSelectChange = (e, ques) => {
    setInputValues((prev) => ({
      ...prev,
      [ques.id]: e.label,
    }))

    if (e.linkedQuestion) {
      const linkedQuesArray = Array.isArray(e.linkedQuestion) ? e.linkedQuestion : [e.linkedQuestion]
      setLinkedQuestions((prev) => ({
        ...prev,
        [ques.id]: linkedQuesArray,
      }))
    } else {
      setLinkedQuestions((prev) => {
        const { [ques.id]: _, ...rest } = prev
        return rest
      })
    }
  }

  //   {
  //     ques?.type === 'dropdown' && (
  //       <Select
  //         isMulti={ques?.isMultiple}
  //         options={ques?.options}
  //         onChange={(e) => handleSelectChange(e, ques)}
  //         styles={{
  //           menu: (provided) => ({
  //             ...provided,
  //             zIndex: 9999,
  //           }),
  //         }}
  //       />
  //     )
  //   }

  const renderQuestions = (questions, isNested = false) => {
    return questions.map((ques, idx) => {
      return (
        <div
          key={idx}
          draggable={!isNested}
          onDragStart={(e) => !isNested && handleDragStart(e, idx)}
          onDrop={(e) => !isNested && handleDrop(e, idx)}
          onDragOver={!isNested && handleDragOver}
          className={`custom-form-builder-theme__question-card d-flex flex-column gap-3 p-3 mb-3 shadow-sm ${isNested ? 'custom-form-builder-theme__question-card--nested' : ''} ${ques?.type === 'input' ? 'visible' : ques?.type === 'dropdown' ? 'visible' : ques?.type === 'Header' || ques?.type === 'subHeader' ? 'visible' : 'invisible d-none'}`}
          style={{
            cursor: 'move',
            height: 'auto',
            borderRadius: isNested ? '5px' : '20px',
            maxWidth: '100%',
            paddingLeft: isNested ? '16px' : '0',
            margin: isNested ? '12px' : '0',
          }}
        >
          {ques?.type == 'Header' ? (
            //  HEADER
            <div className="d-flex flex-column gap-2">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-2">
                  <label className={`${isNested ? 'fw-medium' : 'fw-bold'}`} style={{ maxWidth: '400px' }}>
                    {ques?.label}
                  </label>
                </div>
                <span className="d-flex align-items-center gap-2">
                    <button onClick={() => handleEditQuestion(ques, idx, true)} className="btn btn-sm btn-outline-warning custom-form-builder-theme__icon-btn custom-form-builder-theme__icon-btn--warning" size="sm">
                      <Pencil size={20} strokeWidth={2.25} />
                    </button>
                  <button
                    className="btn btn-sm btn-outline-danger custom-form-builder-theme__icon-btn custom-form-builder-theme__icon-btn--danger"
                    onClick={() => {
                      setDeleteVisible(true)
                      setDeleteQuestionIndex(idx)
                    }}
                  >
                    <Trash2 size={20} strokeWidth={1.75} />
                  </button>
                </span>
              </div>
            </div>
          ) : ques?.type === 'subHeader' ? (
            //Sub Header
            <div className="d-flex flex-column gap-2">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-2">
                  <label className={`${isNested ? 'fw-medium' : 'fw-bold  '}`} style={{ maxWidth: '400px' }}>
                    {ques?.label}
                  </label>
                </div>
                <span className="d-flex align-items-center gap-2">
                    <button onClick={() => handleEditQuestion(ques, idx, true)} className="btn btn-sm btn-outline-warning custom-form-builder-theme__icon-btn custom-form-builder-theme__icon-btn--warning" size="sm">
                      <Pencil size={20} strokeWidth={2.25} />
                    </button>
                  <button
                    className="btn btn-sm btn-outline-danger custom-form-builder-theme__icon-btn custom-form-builder-theme__icon-btn--danger"
                    onClick={() => {
                      setDeleteVisible(true)
                      setDeleteQuestionIndex(idx)
                    }}
                  >
                    <Trash2 size={20} strokeWidth={1.75} />
                  </button>
                </span>
              </div>
            </div>
          ) : ques?.type === 'input' ? (
            // INPUT
            <div className="d-flex flex-column gap-2">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-2">
                  <label className={`${isNested ? 'fw-medium' : 'fw-bold'}`} style={{ maxWidth: '400px' }}>
                    {ques?.label}
                  </label>
                  <CTooltip content={ques?.toolTipValue ? ques?.toolTipValue : 'Add the tooltip'}>
                    <Info size={16} />
                  </CTooltip>
                </div>
                {!isNested && (
                  <span className="d-flex align-items-center gap-2">
                    <button onClick={() => handleEditQuestion(ques, idx)} className="btn btn-sm btn-outline-warning custom-form-builder-theme__icon-btn custom-form-builder-theme__icon-btn--warning" size="sm">
                      <Pencil size={20} strokeWidth={2.25} />
                    </button>
                    <button
                      className="btn btn-sm btn-outline-danger custom-form-builder-theme__icon-btn custom-form-builder-theme__icon-btn--danger"
                      onClick={() => {
                        setDeleteVisible(true)
                        setDeleteQuestionIndex(idx)
                      }}
                    >
                      <Trash2 size={20} strokeWidth={1.75} />
                    </button>
                  </span>
                )}
              </div>

              {ques?.isTextArea ? (
                <textarea value={inputValues[ques?.id]} onChange={(e) => handleInputChange(e, ques?.id)} placeholder="Enter your answer here..." className="form-control" rows="4" />
              ) : (
                <input type="text" onChange={(e) => handleInputChange(e, ques?.id)} value={inputValues[ques?.id]} placeholder="Enter your answer here..." className="form-control" />
              )}
            </div>
          ) : (
            // DROPDOWN
            <div className="d-flex flex-column gap-2">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-2">
                  <label className={`${isNested ? 'fw-medium' : 'fw-bold'}`} style={{ maxWidth: '400px' }}>
                    {ques?.label}
                  </label>
                  <CTooltip content={ques?.toolTipValue ? ques?.toolTipValue : 'Add the tooltip'}>
                    <Info size={16} />  
                  </CTooltip>
                </div>
                {!isNested && (
                  <div className="d-flex align-items-center gap-2">
                    <button onClick={() => handleEditQuestion(ques, idx)} className="btn btn-sm btn-outline-warning custom-form-builder-theme__icon-btn custom-form-builder-theme__icon-btn--warning">
                      <Pencil size={20} strokeWidth={2.25} />
                    </button>
                    <button
                      className="btn btn-sm btn-outline-danger custom-form-builder-theme__icon-btn custom-form-builder-theme__icon-btn--danger"
                      onClick={() => {
                        setDeleteVisible(true)
                        setDeleteQuestionIndex(idx)
                      }}
                    >
                      <Trash2 size={20} strokeWidth={1.75} />
                    </button>
                  </div>
                )}
              </div>

              <Select
                isMulti={ques?.isMultiple}
                options={ques?.options}
                onChange={(e) => handleSelectChange(e, ques)}
                className="basic-multi-select"
                classNamePrefix="select"
                styles={{
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 9999,
                  }),
                }}
              />

              {linkedQuestions[ques.id] && renderQuestions(linkedQuestions[ques.id], true)}
            </div>
          )}
        </div>
      )
    })
  }

  return <div>{fetchedQuestions.questionData && renderQuestions(fetchedQuestions.questionData)}</div>
}

export default DisplayQuestion
